function notInitialized() {
  throw new Error('Audio is not initialized');
}

export default {
  create: notInitialized,
};



// WEBPACK FOOTER //
// ./src/scripts/application/lib/audio_factory.js